module.exports = __webpack_public_path__ + "images/199c26adf02bef2d9e2752f4826a00d1.svg";